import { ComponentProps, FC } from 'react';
import styled, { css } from 'styled-components';

import Text from '@/components/Text';

export const Controls = styled.div`
  border-radius: 4px;
  padding: 3px;
  border: 1px solid ${({ theme }) => theme.colors.lightGray};
  ${({ theme }) => css`
    background: ${theme.colors.white};
  `}
`;

const Button = styled.button<{
  $active?: boolean;
  $gray?: boolean;
  $blackText?: boolean;
}>`
  margin-right: 4px;
  background: transparent;
  display: inline-flex;
  align-items: center;
  padding: 0 16px;
  height: 24px;
  border-radius: 4px;
  transition: 0.2s ease-out background-color;
  &:last-of-type {
    margin: 0;
  }
  &:disabled {
    cursor: not-allowed;
  }
  ${Text} {
    transition: 0.2s ease-out color;
  }
  ${({ $active, theme }) =>
    $active &&
    css`
      box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.08);
      background: ${theme.colors.purple};
    `}
  ${({ $active, $gray, theme }) =>
    $active &&
    $gray &&
    css`
      box-shadow: none;
      background: ${theme.colors.lightGray};
    `}
  ${({ $active, theme }) =>
    !$active &&
    css`
      &:hover {
        ${Text} {
          color: ${theme.colors.black};
        }
      }
    `}
    ${({ $active, $blackText, theme }) =>
    $active &&
    $blackText &&
    css`
      span {
        color: ${theme.colors.black};
      }
    `}
`;

interface Props {
  active: boolean;
  blackText?: boolean;
}

export const ControlsButton: FC<Props & ComponentProps<typeof Button>> = ({
  blackText,
  active,
  children,
  gray,
  ...props
}) => {
  return (
    <Button $blackText={blackText} $gray={gray} $active={active} {...props}>
      <Text
        as="span"
        $type="smallBold"
        $color={!gray ? (active ? 'white' : 'gray') : 'gray'}
      >
        {children}
      </Text>
    </Button>
  );
};
